import { Route } from '@angular/router';
import { LoginGuard, PermissionGuard } from '@simac/ui';

export const FieldWorkspaceRoute: Route = {
  path: 'field-workspace',
  children: [
    {
      path: '',
      loadComponent: () => import('./pages/field-workspace.component').then((m) => m.FieldWorkspaceComponent),
    },
  ],
  canActivate: [LoginGuard, PermissionGuard],
};
